import { render, staticRenderFns } from "./copy-form.vue?vue&type=template&id=b3e454d6&scoped=true&"
import script from "./copy-form.vue?vue&type=script&lang=js&"
export * from "./copy-form.vue?vue&type=script&lang=js&"
import style0 from "./copy-form.vue?vue&type=style&index=0&id=b3e454d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e454d6",
  null
  
)

export default component.exports